import { Spinner } from '@repo/ui/components/molecules/spinner';

/**
 * Full-page loader shown during route transitions.
 * Displays a centered spinner while maintaining the sidebar visible.
 */
export function PageLoader() {
  return (
    <div className="flex size-full justify-center items-center">
      <Spinner />
    </div>
  );
}
